import { call, put, takeEvery } from 'redux-saga/effects';
import {LOGIN_REQUEST} from '../actions/actionTypes';
import { loginSuccess,loginFailure } from '../actions/authActions';

const mockLoginApi = (email, password) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (email === 'test@test.com' && password === 'password') {
        resolve({ email });
      } else {
        reject('Invalid credentials');
      }
    }, 1000);
  });
};

function* loginSaga(action) {
  try {
    const user = yield call(mockLoginApi, action.payload.email, action.payload.password);
    yield put(loginSuccess(user));
  } catch (error) {
    yield put(loginFailure(error));
  }
}

export default function* authSaga() {
  yield takeEvery(LOGIN_REQUEST, loginSaga);
}
